/** Strip spaces from displayed card number. */
export function digitsOnlyPan(cardNumber: string): string {
  return cardNumber.replace(/\s/g, "");
}

/** Luhn check for PAN (digits only). */
export function passesLuhn(panDigits: string): boolean {
  if (!/^\d+$/.test(panDigits) || panDigits.length < 13) {
    return false;
  }
  let sum = 0;
  let alt = false;
  for (let i = panDigits.length - 1; i >= 0; i--) {
    let n = parseInt(panDigits[i]!, 10);
    if (alt) {
      n *= 2;
      if (n > 9) n -= 9;
    }
    sum += n;
    alt = !alt;
  }
  return sum % 10 === 0;
}

export function isAmexPan(panDigits: string): boolean {
  return /^3[47]\d*$/.test(panDigits);
}

export function parseExpiryMmYy(
  expiry: string,
): { month: number; year: number } | null {
  const m = expiry.trim().match(/^(\d{2})\/(\d{2})$/);
  if (!m) return null;
  const month = parseInt(m[1]!, 10);
  const yy = parseInt(m[2]!, 10);
  if (month < 1 || month > 12) return null;
  const year = 2000 + yy;
  return { month, year };
}

/**
 * Expiry is valid through the last moment of the expiry month (in local time).
 */
export function isExpiryNotPast(expiry: string, now = new Date()): boolean {
  const parsed = parseExpiryMmYy(expiry);
  if (!parsed) return false;
  const { month, year } = parsed;
  const endOfExpiryMonth = new Date(year, month, 0, 23, 59, 59, 999);
  return now.getTime() <= endOfExpiryMonth.getTime();
}

export function expectedCvcLength(panDigits: string): { min: number; max: number } {
  if (isAmexPan(panDigits)) {
    return { min: 4, max: 4 };
  }
  return { min: 3, max: 3 };
}

export function cvcLengthValid(cvc: string, panDigits: string): boolean {
  const { min, max } = expectedCvcLength(panDigits);
  const len = cvc.length;
  return len >= min && len <= max;
}
